import { useEffect } from 'react';

/**
 * Hook para gerenciar o badge do app (Badging API)
 * Mostra um contador no ícone do app quando instalado como PWA
 * 
 * Suporte:
 * - Android Chrome: ✅ Funciona perfeitamente
 * - iOS Safari: ⚠️ Suporte limitado (iOS 16.4+)
 * - Desktop: ✅ Chrome, Edge
 */
export const useAppBadge = (count: number) => {
  useEffect(() => {
    // Verifica se a Badging API está disponível
    if ('setAppBadge' in navigator) {
      try {
        if (count > 0) {
          // Define o badge com o contador
          (navigator as any).setAppBadge(count);
        } else {
          // Limpa o badge
          (navigator as any).clearAppBadge();
        }
      } catch (error) {
        // Silently fail - API pode não estar disponível em todos os contextos
        console.debug('App Badge API not available:', error);
      }
    }
  }, [count]);
};

/**
 * Função utilitária para definir o badge programaticamente
 */
export const setAppBadge = async (count: number): Promise<boolean> => {
  if (!('setAppBadge' in navigator)) {
    return false;
  }

  try {
    if (count > 0) {
      await (navigator as any).setAppBadge(count);
    } else {
      await (navigator as any).clearAppBadge();
    }
    return true;
  } catch (error) {
    console.debug('Failed to set app badge:', error);
    return false;
  }
};

/**
 * Função para limpar o badge
 */
export const clearAppBadge = async (): Promise<boolean> => {
  return setAppBadge(0);
};
